import React, { forwardRef, useEffect, useRef, InputHTMLAttributes } from "react";

type IndeterminateCheckboxProps = InputHTMLAttributes<HTMLInputElement> & {
  indeterminate?: boolean;
};

const IndeterminateCheckbox = forwardRef<HTMLInputElement, IndeterminateCheckboxProps>(
  ({ indeterminate, onClick, ...rest }, ref) => {
    const defaultRef = useRef<HTMLInputElement>(null);
    const checkedRef = ref || defaultRef;

    useEffect(() => {
      const inputRef = checkedRef as React.MutableRefObject<HTMLInputElement>;
      if (inputRef.current) {
        inputRef.current.indeterminate = indeterminate || false;
      }
    }, [checkedRef, indeterminate]);

    const handleClick = (e: React.MouseEvent<HTMLInputElement>) => {
      if (onClick) {
        onClick(e);
      }
    };

    return (
      <div className="d-flex align-items-center">
        <input type="checkbox" ref={checkedRef} onClick={handleClick} {...rest} />
      </div>
    );
  },
);

IndeterminateCheckbox.defaultProps = {
  indeterminate: false,
};

export default IndeterminateCheckbox;
